<template>
    <div>
    </div>
</template>

<script>
export default {
  name: 'WxAccount'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/wx/WxAccount.vue